/*
 *  Author: DL
 *  Date: 2020-12-04 18:46:15
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-09 09:34:37
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';
import { Button, Input, Icon } from 'ui';
import styles from './index.less';

export default function(props) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.inputWrapper}>
                <Input prefix="iconfdj" onClick={props.handleInputClick} placeholder="请输入名称搜索" />
            </div>
            <Button type="primary" onClick={props.handleBttnClick}>
                <Icon className="iconlux01" />
                路线
            </Button>
        </div>
    );
}
